import { useSelector } from 'react-redux';

import { RootState } from '../../redux/reducers/rootReducer';
import { DIVISION_CARDS } from '../../utils/constants/division-cards';
import { IMainPage } from '../../utils/types/state-types';
import DivisionCard from '../DivisionCard';
import classes from './divisions.module.scss';

function Divisions() {
  const mainPage = useSelector<RootState, IMainPage | null>(
    (state) => state.mainReducer.mainPage,
  );
  const cards = mainPage?.dreamteamCards.map((item) => {
    const card = DIVISION_CARDS.filter((divison) => divison.title === item.title);

    return {
      ...item,
      to: card[0]?.to || '/',
    };
  });

  return mainPage?.dreamteamShow ? (
    <div className={classes.divisions}>
      <div className={classes.title}>
        {mainPage?.dreamteamTitle || 'Выбери своё направление'}
      </div>
      <div className={classes.cardsWrapper}>
        {cards?.map((card) => (
          <DivisionCard key={card.title} card={card} className={classes.card} />
        ))}
      </div>
    </div>
  ) : null;
}

export default Divisions;
